import {
  SphereBufferGeometry,
  MeshBasicMaterial,
  Object3D,
  Vector3,
  Mesh
} from 'three'

import SimplexNoise from 'simplex-noise'

const noiseScale = new Vector3(1.2, 1.2, 1.2)

export class Ball extends Object3D {
  constructor ({size = 1, index = 0}) {
    super()

    this.setTarget = this.setTarget.bind(this)

    let geometry = new SphereBufferGeometry( size, 10, 10 )
    let material = new MeshBasicMaterial( {color: 0xffffff} )

    this.index = index
    this.mesh = new Mesh( geometry, material )
    this.target = {x: 0, y:0}
    this.simplex = new SimplexNoise()

    this.fakePos = new Vector3(0, 0, 0)

    this.add(this.mesh)
  }

  setTarget (target, elapsed) {
    this.fakePos.x += (target.x - this.fakePos.x) * .05
    this.fakePos.z += (target.z - this.fakePos.z) * .05

    this.position.x = this.fakePos.x + this.simplex.noise2D(0 + (this.index * 3), elapsed * 0.00012) * noiseScale.x
    this.position.y = this.fakePos.y + this.simplex.noise2D(1 + (this.index * 3), elapsed * 0.00012) * noiseScale.y
    this.position.z = this.fakePos.z + this.simplex.noise2D(2 + (this.index * 3), elapsed * 0.00012) * noiseScale.z
  }
}